module.exports = __webpack_public_path__ + "img/hr-tree-01-i-leaves.3714c930.png";